import { publicClient, privateClient } from './client';
import { UrlKeyword } from './UrlKeyword';

const transactionsUrlKeyword = (pub: boolean) => new UrlKeyword(pub ? publicClient : privateClient);
export default transactionsUrlKeyword;
